import Head from "next/head";

import CarrierMain from "@/components/carriers/carrier-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Carriers() {
  return (
    <>
      <Head>
        <title>{seoData.CARRIERS.title}</title>
        <SeoMetaData data={seoData.CARRIERS} />
      </Head>

      <CarrierMain />
    </>
  );
}
